import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { Link } from "react-router-dom";
import { getTrans as T } from "../../../Shared/Language";
import { getLeaveDetailsList, withdrwalLeaveStatus } from "./leaveService";
import TosterService from "../../../Services/Toster-Service/TosterService";
import { TostMsg } from "../../../App";
import LeaveManagerReport from "./CommonComponents/LeaveManagerReport";
import { Paginator } from "primereact/paginator";
import LeaveNavBarItems from "./CommonComponents/LeaveNavBarItems";
import { orgSettings } from "../../../Services/Global-Services/GlobalServices";
import { useSelector } from "react-redux";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import moment from "moment";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";

const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);

function MyLeave() {
  const [leaveData, setLeaveData] = useState([]);
  const toster = useContext(TostMsg);
  const [inputType, setInputType] = useState("date");
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [Isloading, setIsloading] = useState(false);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showLeaveHistory, setShowLeaveHistory] = useState(null);
  const [empIdHierechy, setEmpIdHierechy] = useState(userDetails?.EmpId);
  const [typeAddOnClass, settypeAddOnClass] = useState("U");
  const [showAllUserDataModel, setshowAllUserDataModel] = useState([]);
  const [resonValue, setResonValue] = useState("");
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const ApplyLeaveRequestData = useSelector(
    (state) => state.leave.leaveRequestData
  );
  let Sdate = null;
  let EDate = null;
  const [filterStartDate, setFilterStartDate] = useState(Sdate);
  const [filterEndDate, setFilterEndDate] = useState(EDate);
  const [noData, setNoData] = useState([]);
  const ResontextStyle = {
    maxWidth: "100%",
    // display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    cursor: "pointer",
  };


  useEffect(() => {
    GetMasterSystemAlertList("Leave_Unavailable", 2);
    if (ApplyLeaveRequestData) {
      setFilterStartDate(
        new Date(ApplyLeaveRequestData?.StartDate)?.toISOString()?.split("T")[0]
      );
      setFilterEndDate(
        new Date(ApplyLeaveRequestData?.EndDate)?.toISOString()?.split("T")[0]
      );
      settypeAddOnClass("P");
    } else {
      OrgSettings();
    }
  }, []);

  const OrgSettings = useCallback(async () => {
    let param = {
      OrgId: userDetails?.OrgId,
    };
    try {
      let responce = await orgSettings(param);
      let StartDate = responce?.Data?.filter(
        (element) => element.KeyName == "LeaveFilterStartDate"
      );
      if (StartDate[0]?.Value != null) {
        Sdate = new Date(StartDate[0]?.Value)?.toISOString()?.split("T")[0];
      } else {
        Sdate = new Date(new Date() - 30 * 24 * 60 * 60 * 1000)
          ?.toISOString()
          ?.split("T")[0];
      }
      setFilterStartDate(Sdate);
      let EndDate = responce?.Data?.filter(
        (element) => element?.KeyName == "LeaveFilterEndDate"
      );
      if (EndDate[0]?.Value != null) {
        EDate = new Date(EndDate[0]?.Value)?.toISOString()?.split("T")[0];
      } else {
        EDate = new Date()?.toISOString()?.split("T")[0];
      }
      setFilterEndDate(EDate);
    } catch (error) {
      Sdate = new Date(new Date() - 30 * 24 * 60 * 60 * 1000)
        ?.toISOString()
        ?.split("T")[0];
      EDate = new Date()?.toISOString()?.split("T")[0];
      setFilterStartDate(Sdate);
      setFilterEndDate(EDate);
      setIsloading(false);
    }
  }, []);

  const getLeaveData = async (StatusName, pageNumber, pageSize) => {
    setIsloading(true);
    settypeAddOnClass(StatusName);
    let leaveStatusName;
    if (StatusName) {
      leaveStatusName = StatusName;
    } else {
      leaveStatusName = "U";
    }
    let FilterendOfTheDay = new Date(filterEndDate);
    FilterendOfTheDay.setUTCHours(23, 59, 59, 999);
    const FilterEndDate = new Date(FilterendOfTheDay).toISOString() ?? EDate;
    const param = {
      OrgId: userDetails?.OrgId,
      LoggedInEmpId: userDetails?.EmpId,
      EmpId: empIdHierechy,
      LeaveId: 0,
      HierarchyTypeId: 1,
      leavecategory: leaveStatusName,
      FilterStartDate: new Date(filterStartDate).toISOString() ?? Sdate,
      FilterEndDate: FilterEndDate,
      pageNumber: pageNumber,
      pageSize: pageSize,
    };
    try {
      const data = await getLeaveDetailsList(param);
      let leaveDetailData = await data;
      // setLeaveData(leaveDetailData?.Data);
      setLeaveData(
        leaveDetailData?.Data?.map((item) => ({
          ...item,
          showFull: false,
        }))
      );
      setTotalRecords(leaveDetailData?.Data[0]?.TotalCount);
      setIsloading(false);
    } catch {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  };

  useEffect(() => {
    if (filterStartDate && filterEndDate) {
      getLeaveData(typeAddOnClass, pageNumber, pageSize);
    }
  }, [filterStartDate, filterEndDate]);

  const handleResonChange = (e) => {
    setResonValue(e.target.value);
  };
  const handleWithdrwalSubmit = async (submitType) => {
    if (submitType == "Withdrwal") {
      setIsloading(true);
      const body = {
        id: showAllUserDataModel?.Id ?? 0,
        RequestorId: userDetails?.EmpId,
        Reason: resonValue ?? "",
      };
      try {
        await withdrwalLeaveStatus(body);
        getLeaveData("C", pageNumber, pageSize);
        GetMasterSystemAlertList("Leave_Withdrawal", 0);
        setResonValue("");
        setshowAllUserDataModel([]);
        setIsloading(false);

        document.querySelector("#pending-request .btn-close")?.click();
      } catch (err) {
        toster.current.warn(err?.Message);

        setIsloading(false);
        document.querySelector("#pending-request .btn-close")?.click();
      }
    }
  };

  const onPageChange = async (event) => {
    setFirst(event.first);
    setRows(event.rows);
    await getLeaveData(typeAddOnClass, event.page + 1, event.rows);
  };

  const handleToggle = (index) => {
    if (showLeaveHistory === index) {
      setShowLeaveHistory(null);
    } else {
      setShowLeaveHistory(index);
    }
  };

  const showFull = (id, expand) => {
    setLeaveData((prev) =>
      prev.map((item) =>
        item.Id === id ? { ...item, showFull: expand } : item
      )
    );
  };

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setNoData(msg?.Desc);
      }
    });
  }, []);
  useEffect(() => {
    if (masterSystemAlertData?.length > 0) {
      toster.current.success(masterSystemAlertData);
    }
  }, [masterSystemAlertData]);
  useEffect(() => { }, [leaveData, empIdHierechy]);
  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      {/* <!-- row --> */}
      <div className="container-fluid position-relation">
        <div className="row g-3">
          <div className="form-head  mb-3">
            <div className="row">
              <div className="col-lg-5">
                <div className="">
                  <h2 className="font-w600 mb-0">{T("Leaves")}</h2>
                  <p className="text-light">
                    View your leave balance, history, upcoming leaves, and
                    pending requests.
                  </p>
                </div>
              </div>
              <div className="col-lg-7">
                <LeaveNavBarItems />
              </div>
            </div>
          </div>

          <div className="col-xl-8">
            <div className="leave-card tile-grid tile-grid-v1">
              <div className="card">
                <div className="tab-tabsa">
                  <div className="div">
                    <a onClick={() => getLeaveData("U")}>
                      <h2
                        className={`font-w600 mb-0 ${typeAddOnClass == "U" ? "h2active" : ""
                          }`}
                      >
                        Upcoming
                      </h2>
                    </a>
                  </div>
                  <div className="div">
                    <a onClick={() => getLeaveData("C")}>
                      <h2
                        className={`font-w600 mb-0 ${typeAddOnClass == "C" ? "h2active" : ""
                          }`}
                      >
                        Archived
                      </h2>
                    </a>
                  </div>
                  <div className="div">
                    <a onClick={() => getLeaveData("P")}>
                      <h2
                        className={`font-w600 mb-0 ${typeAddOnClass == "P" ? "h2active" : ""
                          }`}
                      >
                        Pending
                      </h2>
                    </a>
                  </div>
                  <div className="div side-filter w-auto">
                    <div className="filter-down">
                      <div className="tab-tabsa1">
                        <div className="form-group d-gridcss mb-0">
                          <label>Start Date</label>
                          <input
                            type={inputType}
                            format="dd-mm-yyyy"
                            name="startDate"
                            className="form-control"
                            placeholder="Start Date"
                            onFocus={() => setInputType("date")}
                            onBlur={() => setInputType("text")}
                            value={filterStartDate}
                            onChange={(e) => setFilterStartDate(e.target.value)}
                          />

                          <label>End Date</label>
                          <input
                            type={inputType}
                            format="dd-mm-yyyy"
                            name="endDate"
                            className="form-control"
                            placeholder="End Date"
                            onFocus={() => setInputType("date")}
                            onBlur={() => setInputType("text")}
                            value={filterEndDate}
                            onChange={(e) => setFilterEndDate(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card filter-down d-none">
                <div className="card-body">
                  <div className="tab-tabsa1">
                    <div className="widthdiv">
                      <select
                        className="default-select wide form-control"
                        id="validationCustom05"
                      >
                        <option data-display="Select Status">
                          Select Status
                        </option>
                        <option value="html">Upcoming</option>
                        <option value="css">Approved</option>
                        <option value="javascript">Pending</option>
                      </select>
                    </div>

                    <div className="widthdiv">
                      <select
                        className="default-select wide form-control"
                        id="validationCustom05"
                      >
                        <option data-display="Select Type">Select Type</option>
                        <option value="html">Direct Report</option>
                        <option value="css">Hierarchy</option>
                      </select>
                    </div>

                    <div className="apply-filter">
                      <Link to="">{T("Apply")}</Link>
                    </div>
                  </div>
                </div>
              </div>

              {leaveData?.map((leave, index) => {
                return (
                  <div key={index}>
                    <div className="leave-cards">
                      <div key={index}>


                        <div className="my-leavecard-list">
                          <div className="leave-container">
                            <img
                              src="images/org-img/leave/upcoming1.png"
                              className="w-100  leave-image"
                            />
                            <div className="leave-count-overlay">
                              {leave?.Days}
                            </div>
                          </div>
                          <div className="leave-body">
                            <div class="leave-type-row">
                              <span className="leave-type">
                                {" "}
                                {leave?.LeaveTypeName}
                              </span>
                            </div>
                            <p className="leave-description">

                              {leave?.Reason?.length > 75 &&
                                !leave?.showFull ? (
                                <>
                                  {leave?.Reason.slice(0, 75)}...
                                  <span
                                    style={{
                                      color: "red",
                                      cursor: "pointer",
                                      fontSize: "12px",
                                    }}
                                    onClick={() => showFull(leave.Id, true)}
                                  >
                                    read more
                                  </span>
                                </>
                              ) : (
                                leave?.Reason
                              )}
                              {leave?.showFull && (
                                <span
                                  style={{
                                    color: "red",
                                    cursor: "pointer",
                                    fontSize: "12px",
                                  }}
                                  onClick={() => showFull(leave.Id, false)}
                                >
                                  &nbsp; read less
                                </span>
                              )}

                            </p>
                            <div className="leave-meta">
                              <div className="meta-item">
                                <span className="meta-label">From:</span>
                                <span className="meta-value">{moment(leave?.StartDate).format("MMM DD YYYY")}</span>
                              </div>
                              <div className="meta-item">
                                <span className="meta-label">To:</span>
                                <span className="meta-value"> {moment(leave?.EndDate).format("MMM DD YYYY")}</span>
                              </div>
                              <div className="meta-item">
                                <span className="meta-label">Half Day:</span>
                                <span className="meta-value">
                                  {leave?.IsHalfDay == false && (
                                    <span>No</span>
                                  )}{" "}
                                  {leave?.IsHalfDay == true &&
                                    leave?.HalfPreference == "1" && (
                                      <span>First Half</span>
                                    )}{" "}
                                  {leave?.IsHalfDay == true &&
                                    leave?.HalfPreference == "2" && (
                                      <span>Second Half</span>
                                    )}
                                </span>
                              </div>
                              <span className="innerdiv ml-auto">
                                {leave?.LeaveStatusId === 103 && (
                                  <a className="approved-status-btn">
                                    <i
                                      className="fa fa-check"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    {leave?.LeaveStatusName}
                                  </a>
                                )}
                                {leave?.LeaveStatusId != 103 && (
                                  <a className={leave?.LeaveStatusName}>
                                    {/* // <a className="Applied"> */}
                                    <i
                                      className="fa fa-clock-o"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    {leave?.LeaveStatusName}
                                  </a>
                                )}
                                {((leave?.LeaveStatusId == 101 &&
                                  leave?.EndDate.split(" ") >=
                                  new Date().toISOString().split("T")[0]) ||
                                  (leave?.LeaveStatusId != 102 &&
                                    leave?.EndDate.split(" ") >=
                                    new Date().toISOString().split("T")[0] &&
                                    leave?.LeaveStatusId != 104)) && (
                                    <a
                                      className="withdraw-status-btn"
                                      data-bs-toggle="modal"
                                      data-bs-target="#pending-request"
                                      onClick={() => {
                                        setshowAllUserDataModel(leave);
                                      }}
                                    >
                                      <i
                                        className="fa fa-clock-o"
                                        aria-hidden="true"
                                      ></i>{" "}
                                      Withdraw
                                    </a>
                                  )}
                              </span>

                            </div>

                          </div>
                          <div className="innerdiv show-more"
                            onClick={() => handleToggle(index)}
                          >
                            {showLeaveHistory === index ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-chevron-down"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                                />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-chevron-up"
                                viewBox="0 0 16 16"
                              >
                                {" "}
                                <path
                                  fillRule="evenodd"
                                  d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"
                                />
                              </svg>
                            )}
                          </div>
                        </div>


                        {showLeaveHistory === index && (
                          <div className="my-leavedetail-view">
                            {leave?.EmpLeaveHistory?.length > 0 ? (
                              leave?.EmpLeaveHistory?.reverse()?.map(
                                (history, Hindex) => (
                                  <div key={history?.Id}>
                                    <ul className="timeline" key={Hindex}>
                                      <li className="timeline-inverted">
                                        <div className="timeline-badge">1</div>
                                        <div className="timeline-panel">
                                          <div className="flex-container flex-around">
                                            <div className="timeline-heading">
                                              <h4 className="timeline-title">
                                                {history?.ModifiedByName}
                                              </h4>

                                              {history?.LeaveStatusName === "Applied" && history?.Reason ? (
                                                <p className="timeline-title">{history.Reason}</p>
                                              ) : history?.Comments ? (
                                                <p className="timeline-title">{history.Comments}</p>
                                              ) : null}

                                              {/* {history?.CreatedBy === history?.ModifiedBy ? (
                                                history?.Reason?.length > 0 && (
                                                  <p className="timeline-title">
                                                    {history.Reason}
                                                  </p>
                                                )
                                              ) : (
                                                history?.Comments?.length > 0 && (
                                                  <p className="timeline-title">
                                                    {history.Comments}
                                                  </p>
                                                )
                                              )} */}
                                              <h5 className="leavestatus-timeline">
                                                <i
                                                  className="fa fa-clock-o"
                                                  aria-hidden="true"
                                                ></i>
                                                {history?.LeaveStatusName}
                                                <span>
                                                  on{" "}
                                                  {moment(
                                                    history?.ModifiedDate
                                                  ).format("MMM DD YYYY")}{" "}
                                                  (
                                                  {new Date(
                                                    history?.ModifiedDate
                                                  ).toLocaleTimeString([], {
                                                    hour: "numeric",
                                                    minute: "2-digit",
                                                  })}
                                                  )
                                                </span>
                                              </h5>
                                            </div>
                                            <div className="timeline-clock">
                                              <p>
                                                <i className="glyphicon glyphicon-time"></i>
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                )
                              )
                            ) : (
                              <div>No Leave History Found.</div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
              {leaveData?.length == 0 ? (
                <div className="card">
                  <div className="leave-notfound">
                    <img src="/images/no-data-found/No_leave.png" />
                    <p>{noData}</p>
                  </div>
                </div>
              ) : (
                <div className="card pagination-css">
                  <Paginator
                    first={first}
                    rows={rows}
                    totalRecords={totalRecords}
                    rowsPerPageOptions={[10, 20, 30]}
                    onPageChange={onPageChange}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="col-xl-4">
            <div className="row sidecarddd">
              <div className="col-xl-12">
                <LeaveManagerReport />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="delete-ed">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title m-auto">withdrawal</h5>
            </div>
            <div className="modal-body">
              <div className="ng-tns-c57-16">
                <p>Are you sure that you want to proceed?</p>
              </div>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="btn btn-danger light"
                data-bs-dismiss="modal"
              >
                Cencel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                withdrawal
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="pending-request">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content withdrawleave">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
              <div className="img">
                <img src="/images/org-img/leave/withdrawal.png" />
              </div>
            </div>
            <form onSubmit={handleWithdrwalSubmit}>
              <div className="modal-body text-center">
                <strong className="modal-title d-block">
                  Withdrawal Request
                </strong>

                <div className="inner">
                  <div className="h-avatar">
                    <LazyImage
                      className="avatar"
                      src={userDetails?.ProfileImage}
                      alt={userDetails?.FullName}
                    />
                  </div>
                  <div className="para-detail">
                    <span className="name-p">
                      {showAllUserDataModel?.EmployeeName}
                    </span>
                    applied
                    <span>
                      <b>From </b>
                      {moment(showAllUserDataModel?.StartDate).format(
                        "MMM DD YYYY"
                      )}
                    </span>
                    <span>
                      <b>To </b>
                      {moment(showAllUserDataModel?.EndDate).format(
                        "MMM DD YYYY"
                      )}
                    </span>
                    <span>
                      for
                      {showAllUserDataModel.IsHalfDay == false && (
                        <span>No</span>
                      )}{" "}
                      {/* {showAllUserDataModel.IsHalfDay == true && (
                        <span>Yes</span>
                      )} */}
                      {showAllUserDataModel?.IsHalfDay == true &&
                        showAllUserDataModel?.HalfPreference == "1" && (
                          <span>First</span>
                        )}{" "}
                      {showAllUserDataModel?.IsHalfDay == true &&
                        showAllUserDataModel?.HalfPreference == "2" && (
                          <span>Second</span>
                        )}{" "}
                      <b> Half Day </b>
                    </span>
                  </div>
                </div>
                <label className="mt-3">Reason</label>
                <textarea
                  rows="2"
                  cols="1"
                  className="form-control"
                  value={resonValue}
                  onChange={handleResonChange}
                  placeholder="Reason"
                  maxLength={500}
                ></textarea>
                <div
                  style={{
                    textAlign: "right",
                    fontSize: "12px",
                    position: "absolute",
                    right: "46px",
                    bottom: "18px",
                    color: resonValue.length === 500 ? "red" : "#555",
                  }}
                >
                  {resonValue.length}/{500}
                </div>
              </div>
            </form>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={() => handleWithdrwalSubmit("Withdrwal")}
                className="savebtn-click"
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
      <TosterService ref={toster} />
      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}
export default MyLeave;
